<template>
    <div id="bfMerchants">
        <van-list
            v-model="loading"
            :finished="finished"
            @load="onLoad"
        >
            <van-nav-bar :style="$route.query.businessProperty==2?{'background':'#DEA286'}:{}" :title="$route.query.businessProperty==2?'缤纷精选':'欣周边'" left-arrow @click-left="$router.back()"/>
            <div class="bfMerchantsBody">
                <div v-if="$route.query.businessProperty==2">
                    <div class="bodyContenBf" v-for="(item, index) in zbIndexList" :key="index">
                        <div class="bodyContenHeard clearfix" @click="$router.push('/bfMerchantsShop?businessNumber='+item.businessNumber+'&businessProperty='+item.businessProperty)">
                            <van-image :src="baseUrl.imgUrl + item.businessLogo"/>
                            <div style="display:inline-block;float:left;padding-left:10px;">
                                <p class="heardTietle">{{item.businessName}}</p>
                                <p class="heardDesc">销量{{item.totalSales}}｜{{item.praise}}个用户好评</p>
                            </div>
                        </div>
                        <div class="bodyContenBody">
                            <van-grid :border="false" :column-num="3" class="bodyContenBodyGrid">
                                <van-grid-item v-for="(data, index) in item.sjbusinesslist" :key="index">
                                    <van-image @click="$router.push('/goodsDetail/'+data.productId)" :src="baseUrl.imgUrl + data.productImage.split(',')[0]" />
                                    <div class="gridItemTitle">
                                        <p class="pTitle">{{data.productName}}</p>
                                        <p class="priceTitle">￥{{data.productPrice}}</p>
                                    </div>
                                </van-grid-item>
                            </van-grid>
                        </div>
                    </div>
                </div>
                <div class="bodyConten"
                    v-else
                    v-for="(item, index) in zbIndexList" :key="index"
                    @click="$router.push('/bfMerchantsShop?businessNumber='+item.businessNumber+'&businessProperty='+item.businessProperty)">
                    <div class="bodyConten-img">
                        <van-image :src="baseUrl.imgUrl + item.businessLogo"/>
                    </div>
                    <div class="bodyConten-desc">
                        <p class="bodyConten-desc-title">{{ item.businessName }}</p>
                        <p class="bodyConten-desc-subTitle">{{ item.businessDetails }}</p>
                        <van-image class="bodyConten-desc-logo" fit="contain" :src="baseUrl.imgUrl + item.businessServerIntroduce"/>
                    </div>
                </div>
            </div>
        </van-list>
    </div>
</template>
<script>
import baseUrl from '@/config/baseUrl';
import { mapActions, mapState } from 'vuex';
export default {
    name: 'ZbIndex',
    data() {
        return {
            baseUrl,
            loading: false,
            finished: false,
            searchData: {
                businessProperty: this.$route.query.businessProperty==='2'?2:4,
                page: 1,
                rows: 10
            }
        };
    },
    computed: {
        ...mapState('zbIndex', {
            zbIndexList: 'zbIndexList'
        })
    },
    created(){
        this.onLoad();
    },
    methods: {
        ...mapActions('zbIndex', {
            getZbIndexList: 'getZbIndexListAction'
        }),
        onLoad() {
            this.loading = true;
            this.getZbIndexList(this.searchData).then((res) => {
                this.searchData.page++;
                this.loading = false;
                if(res.length<10) {
                    this.finished = true;
                }
            });
        }
    }
};
</script>
<style lang="scss">
    #bfMerchants{
        .van-nav-bar{
            background: #4BA4FB;
            padding-bottom: 50px;
            .van-nav-bar__left{
                top: 0;
            }
            .van-icon-arrow-left{
                font-size: 21px;
                color: #fff;
            }
            .van-nav-bar__title{
                font-size:21px;
                font-family:PingFang SC;
                font-weight:bold;
                color:rgba(255,255,255,1);
            }
        }
        .bfMerchantsBody{
            padding: 0 13px;
            position: relative;
            top: -45px;
            z-index: 999;
            .bodyConten:last-child{
                margin-bottom: 0;
            }
            .bodyConten{
                display: flex;
                background:#fff;
                border-radius:5px;
                padding: 15px 10px;
                margin-bottom: 30px;

                .bodyConten-img {
                    float: left;

                    .van-image {
                        width: 28px;
                        height: 28px;
                        border-radius: 50%;
                        overflow: hidden;
                    }
                }
                .bodyConten-desc {
                    flex: 1;
                    margin-left: 15px;

                    .bodyConten-desc-title {
                        font-size: 17px;
                        font-weight: bold;
                        color: #333333;
                        margin-bottom: 12px;
                    }
                    .bodyConten-desc-subTitle {
                        line-height: 24px;
                        font-size: 15px;
                        color: #666666;
                        margin-bottom: 12px;
                    }
                    .bodyConten-desc-logo {
                        width: 100%;
                        border-radius: 5px;
                        overflow: hidden;
                    }
                }
            }
            .bodyContenBf:last-child{
                margin-bottom: 0;
            }
            .bodyContenBf{
                background:#fff;
                border-radius:5px;
                padding: 0 10px 8px;
                margin-bottom: 30px;
                .bodyContenHeard{
                    text-align: left;
                    .van-image{
                        float: left;
                        width:60px;
                        height: 60px;
                        img{
                            position: relative;
                            top: -10px;
                            z-index: 9999;
                            border-radius:3px;
                        }
                    }
                    .heardTietle{
                        font-size:18px;
                        font-family:PingFang SC;
                        font-weight:bold;
                        color:rgba(0,0,0,1);
                        line-height:35px;
                    }
                    .heardDesc{
                        font-size:12px;
                        font-family:PingFang SC;
                        font-weight:500;
                        color:rgba(159,159,159,1);
                    }
                }
                .bodyContenBody{
                    .bodyContenBodyGrid{
                        .van-grid-item__content{
                            padding: 0 5px;
                        }
                        .van-image{
                            img{
                                width: 100%;
                                height:95px;
                                border-radius:5px;
                            }
                        }
                        .gridItemTitle{
                            text-align: left;
                            width: 100%;
                            padding: 5px 0;
                            background: #FAFAFA;
                            border-radius:5px;
                            .pTitle{
                                white-space: nowrap;
                                text-overflow:ellipsis;
                                overflow:hidden;
                                width: 90px;
                                font-size:12px;
                                font-family:PingFang SC;
                                font-weight:bold;
                                color:rgba(51,51,51,1);
                                line-height:20px;
                                margin-left: 5px;
                            }
                            .priceTitle{
                                margin-left: 5px;
                                font-size:10px;
                                font-family:PingFang SC;
                                font-weight:bold;
                                color:rgba(232,91,77,1);
                                line-height:18px;
                            }
                        }
                    }
                }
            }
        }
    }
</style>
